import { render } from "./Filter.vue?vue&type=template&id=3997a7e9"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"
script.render = render

export default script